import React from 'react';
import content from '../lib/i18n';
import Modal from './Modal';
import { Text } from 'pp-react';
import styles from './checkoutError.less';
const i18n = content('shared/components/checkoutError');

const CheckoutError = React.memo(({ fptiInfo }) => {
  return (
    <Modal titleId={i18n('title.checkout-error-title')} showOnMount={true}>
      <>
        <div className={styles.errorModalIcon}>
          <img
            src='https://www.paypalobjects.com/images/Cause/ic_critical_lg.svg'
            alt='confirmpng'
            height='82'
            width='82'
          />
        </div>
        <div className={styles.errorModalContent}>
          <Text as='h2' size='xl3'>
            {i18n('title.checkout-error-title')}
          </Text>
          <Text className={styles.errorModalSubtitle} as='p' size='md'>
            {i18n('title.checkout-error-subTitle')}
          </Text>
        </div>
      </>
    </Modal>
  );
});

export default CheckoutError;
